import { Component, Element, h } from '@stencil/core';

@Component({
  tag: 'lar-list',
  styleUrl: 'list.scss',
  shadow: false
})

export class ListItem {
  @Element() el!: HTMLElement;

  render() {
    return <slot></slot>;
  }
}
